export const API_BASE_URL = "https://api-tester.mathteachers.uz";
// export const API_BASE_URL = "http://0.0.0.0:5026";
export const CDN_URL = "https://storage.mathteachers.uz";

export const TEST_TIME = 2 * 60 * 60 * 1000